import { render, staticRenderFns } from "./TicketGroupSeatBadge.vue?vue&type=template&id=99d4296a&"
import script from "./TicketGroupSeatBadge.vue?vue&type=script&lang=ts&"
export * from "./TicketGroupSeatBadge.vue?vue&type=script&lang=ts&"
import style0 from "./TicketGroupSeatBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports